import React from 'react';
import { componentService } from 'js/services/component.service';
import { usePortletConfig, withPortlet } from 'js/components/system/Portlet';
import { WebContent as WebContentCommon } from 'js/components/system/WebContent';

import { WEB_CONTENT } from './constants';

export const WebContentBare = () => {
    const { id: wcId } = usePortletConfig();

    return <WebContentCommon id={wcId} />;
};

export const WebContent = withPortlet()(WebContentBare);

componentService.registerPageComponents({ [WEB_CONTENT]: WebContent });
